import { Outlet } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import logo from '../../assets/img/image-1@2x.png'
import buttonLogout from '../../assets/img/button-logout.svg'
import { clearAuth } from '../../store/auth/slice'


const Guk = () => {

  const dispatch = useDispatch()

  const logoutHandler = () => {
    dispatch(clearAuth())
  }

  return (
    <div className="min-h-screen bg-[#f9fafb] font-[Inter]">
      <header className="flex flex-col gap-4 px-4 pt-4 pb-4 sm:px-6 sm:pt-6 sm:pb-5 lg:flex-row lg:items-start lg:justify-between lg:gap-6 lg:px-[3.125rem] lg:pt-[2rem] lg:pb-[1.5rem]">
        <div className="flex items-start gap-4 sm:gap-6 lg:gap-[3.5rem]">
          <img src={logo} alt="" className="h-12 w-auto sm:h-16 lg:h-[4.875rem] lg:w-[7.5rem] object-cover shrink-0" />
          <div className="flex flex-col gap-[0.312rem] text-[#111827] lg:max-w-[22.5rem]">
            <p className="m-0 text-[0.875rem] sm:text-[1rem] font-medium leading-snug">
              Система регистрации и ведения результатов олимпиад и конкурсов
            </p>
            <p className="m-0 text-[0.75rem] sm:text-[0.875rem]">
              довузовских общеобразовательных организаций
            </p>
          </div>
        </div>
        <img
          src={buttonLogout}
          alt=""
          onClick={logoutHandler}
          className="h-12 w-12 lg:h-[3.75rem] lg:w-[3.75rem] cursor-pointer rounded-[10px] self-end lg:self-auto"
        />
      </header>

      <main className="flex flex-col gap-[1.25rem] lg:gap-[1.5rem] px-4 sm:px-6 lg:px-[3.125rem] pb-[2rem] lg:pb-[3.125rem]">
        <Outlet />
      </main>
    </div>
  )
}

export default Guk
